import {RouteRecordRaw} from "vue-router";
import LayoutView from "@/views/share/LayoutView.vue";
import HeaderView from "@/views/share/HeaderView.vue";
import {session} from "@/model/session";
import tab from "@/views/activity/tab";
import {UserAgent} from "@/model/user_agent";

export default <Array<RouteRecordRaw>>[
    {
        path: "/activities",
        meta: {auth: true},
        component: LayoutView,
        children: [
            {
                path: "",
                meta: {auth: true},
                beforeEnter: async (to, _, next) => {
                    to.meta.material = await session.material()
                    return next()
                },
                components: {
                    default: () => import(/* webpackChunkName: "activities" */ './ActivitiesPage.vue'),
                    header: HeaderView,
                },
            }
        ]
    },
    {
        path: '/activity',
        meta: {auth: true},
        component: LayoutView,
        children: [
            {
                path: '',
                meta: {auth: true},
                beforeEnter: async (to, _, next) => {
                    const m = await session.material()
                    to.meta.material = m
                    if (to.query.tags == null || to.query.tags.length != 3) return next('/')
                    const tags = to.query.tags as string[]
                    // console.log(tags, m.tags.tags[tags[0]], m.tags.tags[tags[1]], m.tags.tags[tags[2]])
                    if (m.tags.tags[tags[0]].category != '模式' || m.tags.tags[tags[1]].category != '场景' || m.tags.tags[tags[2]].category != '行业') return next('/')
                    return next()
                },
                components: {
                    default: () => import(/* webpackChunkName: "activity.new" */ './ActivityNewForm.vue'),
                    header: HeaderView,
                },
            },
            {
                path: ':activity_id',
                meta: {auth: true},
                beforeEnter: async (to, _, next) => {
                    const ua = to.meta.agent as UserAgent
                    for (let i = ua.meta.activities.length - 1; i >= 0; i--) {
                        if (to.params.activity_id == ua.meta.activities[i].data.activity_id) {
                            to.meta.activity = ua.meta.activities[i]
                        }
                    }
                    if (!to.meta.activity) next('/')
                    else return next()
                },
                components: {
                    default: () => import(/* webpackChunkName: "activity" */ './ActivityPage.vue'),
                    header: HeaderView,
                },
                children: tab
            },
        ]
    }
]

export interface IModuleInfo {
    key: string
    name: string
    info: string
    require: boolean
}

export const moduleInfoMap: { [key: string]: IModuleInfo } = {
    'basic': {
        key: 'basic',
        name: '基础',
        require: true,
        info: '活动的基础功能，包含活动标题、时间、地点、简介等基本信息展示'
    },
    'group': {
        key: 'group',
        name: '团购',
        require: true,
        info: '支持阶梯团、团长券、分销、预热券等。顾客报名后能在所有参与活动的分支下消费'
    },
    'retail': {key: 'retail', name: '零售', require: true, info: '单个或多个商品限时特价抢购活动'},
    'suite': {key: 'suite', name: '套餐', require: true, info: '课程包、套餐、套组、礼包、等限时特价抢购活动，支持自选'},
    'forward': {key: 'forward', name: '转发有礼', require: false, info: '用礼品激励顾客转发活动给好友'},
    'recommend': {key: 'recommend', name: '推荐报名有礼', require: false, info: '用礼品激励顾客推荐好友下单报名'},
    'red_pack': {key: 'red_pack', name: '引流红包', require: false, info: '随机现金红包激励顾客转发'},
    'introduction': {
        key: 'introduction',
        name: '内容',
        require: true,
        info: '业务、资质等内容的介绍，支持展示图片、文案，设置活动规则等'
    },
    'sign': {key: 'sign', name: '报名', require: true, info: '活动报名表单，支持自定义报名字段'}
}